// extracted by mini-css-extract-plugin
export default {"circle1":"Circle_circle1__tdL9x","circle2":"Circle_circle2__ovyWI","circle3":"Circle_circle3__AvnaV","circle4":"Circle_circle4__zOnUK"};